<script setup>

import {APP} from "@/config/app";

const cdn = APP.MyWealthMode ? APP.CdnMwpBaseUrl : APP.CdnMwiBaseUrl
</script>

<template>
  <div class="flex flex-col">
    <main class="relative overflow-hidden">
      <div class="absolute inset-0 w-full" />
      <section class="relative z-10">
        <div class="flex flex-col pt-40">
          <div class="mx-auto max-w-7xl flex flex-col justify-center items-center gap-6 px-8 xl:px-0">
            <h1 class="text-8xl text-black">404</h1>

            <h2 class="text-black">Page not found</h2>

            <p class="max-w-md text-center">
              We couldn’t find the page you’re looking for. It might have been moved or doesn’t exist anymore.
            </p>
          </div>

          <div class="hidden md:flex -ml-2 -mb-2 -mt-10">
            <img :src="`${cdn}/placeholder/error-symbols.png`" alt="">
          </div>
          <img :src="`${cdn}/placeholder/error-symbols-mobile.png`" alt="" class="flex md:hidden">
        </div>
      </section>
    </main>
  </div>
</template>

<style></style>
